module.exports = __webpack_public_path__ + "static/pic06-815f33f9c5ddbe5812dd6c7740769334.png";